import IconUrl from '@/assets/red-star.png'

export function setDocumentTitle(title: string): void {
  document.title = title
  if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
    const iframe = document.createElement('iframe')
    iframe.src = IconUrl
    iframe.style.display = 'none'
    const fn = function () {
      setTimeout(function () {
        iframe.removeEventListener('load', fn)
        document.body.removeChild(iframe)
        console.log('title', document.title)
      }, 0)
    }
    iframe.addEventListener('load', fn)
    document.body.appendChild(iframe)
  }
}
